import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  makeStyles,
  Theme,
  createStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";
import {
  Grid,
  IconButton,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
  Typography,
} from "@material-ui/core";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import RemoveCircleOutlineIcon from "@material-ui/icons/RemoveCircleOutline";
import SelectStoreMenu from "./SelectStoreMenu";
import GraphContentTenpoMobaku from "./GraphContentTenpoMobaku";
import MultiDatePicker from "../common/MultiDatePicker";

import { DateTime } from "luxon";
import {
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  CircularProgress,
} from "@material-ui/core";
import GraphWeather from "./Weather/GraphWeather";
import { postRequest } from "../../apis/axiosAction";
import {
  selectFirstTenpoItem,
  selectSecondTenpoItem,
} from "../../features/tenpoStatusSlice";
import { getAllExistingSejStores } from "../../data/existingSejStores";
import { db } from "../../firebase";
import { initData } from "./DataFormat";
import { selectExclusiveFlg } from "../../features/marketAreaStatusSlice";
import GraphContentZennenhiTenpoMobaku from "./GraphContentZennenhiTenpoMobaku";
import TableContentTenpoMobaku from "./TableContentTenpoMobaku";
import TableContentZennenhiTenpoMobaku from "./TableContentZennenhiTenpoMobaku";
import { getWeatherInfo } from "./Weather/weatherApi";
import { apiRequest } from "../../apis/util";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    graphBox: {
      position: "relative",
      left: "8px",
      height: "100%",
      overflowY: "scroll",
      overflowX: "hidden",
    },
    closeButton: {
      position: "absolute",
      left: "96%",
      "&:hover": {
        backgroundColor: "lightgray",
      },
    },
    errorDialogTitle: {
      textAlign: "right",
      padding: "0px",
    },
    errorDialogContent: {
      color: "red",
      textAlign: "center",
    },
    titlePaperFirst: {
      padding: "10px 0px",
      margin: "10px 0px",
      textAlign: "center",
      backgroundColor: "#0000FF",
      color: "#FFF",
    },
    titlePaperSecond: {
      padding: "10px 0px",
      margin: "10px 0px",
      textAlign: "center",
      backgroundColor: "#00B050",
      color: "#FFF",
    },
    circularProgress: {
      position: "absolute",
      top: "35%",
      left: "45%",
      opacity: "0.8",
      color: "#CCC",
    },
    overLayer: {
      position: "relative",
      width: "100%",
      height: "100%",
      top: "0",
      left: "0",
    },
    errorDialog: {
      position: "fixed",
      width: "38%",
      height: "20%",
      top: "30%",
      left: "31%",
      backgroundColor: "#FFF",
      border: "solid 1px #CCC",
      borderRadius: "10px",
      padding: "16px",
      opacity: 1,
      zIndex: 100,
      display: "flex",
      textAlign: "center",
      alignItems: "center",
      justifyContent: "center",
      "&:focus": {
        outline: "none",
      },
    },
    errorDialogCloseButton: {
      position: "absolute",
      top: "4px",
      right: "3%",
    },
    backLayer: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(0,0,0,0.5)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 100,
    },
  })
);

const TenpoGraphAnalysis: React.FC<{ holiday: string[]; key: number }> = ({
  holiday,
  key,
}) => {
  const classes = useStyles({});
  const dispatch = useDispatch();
  // const common_api_url: string = process.env.REACT_APP_COMMON_API!;
  // const common_api_url =
  //   "http://localhost:19001/outside/call-common-process-api";
  const firstTenpoItem = useSelector(selectFirstTenpoItem);
  const secondTenpoItem = useSelector(selectSecondTenpoItem);
  const tenpoFirstName = getAllExistingSejStores().store_data;
  const tenpoSecondName = getAllExistingSejStores().store_data;
  const logFlag = React.useRef(false);
  const initDate = React.useRef<string[]>([]);
  const isDoubleUpdate = React.useRef(false);
  const axisChange = React.useRef(false);
  const [loading, setLoading] = React.useState(false);
  const [errorDialog, setErrorDialog] = React.useState(false);
  const [initGraph, setInitGraph] = React.useState(false);
  const [data, setData] = React.useState<any[]>();
  const [yearOnYear, setYearOnYear] = React.useState(false);
  const [yearOnYearMode, setYearOnYearMode] = React.useState(false);
  const [tableOpen, setTableOpen] = React.useState("none");
  const [firstDate, setFirstDate] = React.useState<string[]>([]);
  const [secondDate, setSecondDate] = React.useState<string[]>([]);
  const [firstDayWeather, setFirstDayWeather] = React.useState({});
  const [secondDayWeather, setSecondDayWeather] = React.useState({});
  const [firstOneYearWeather, setFirstOneYearWeather] = React.useState([]);
  const [secondOneYearWeather, setSecondOneYearWeather] = React.useState([]);
  const [baseAxis, setBaseAxis] = React.useState(0);
  const [errorMessage, setErrorMessage] = React.useState(<></>);
  const [radioAxisMode, setRadioAxisMode] = React.useState<string>("timeComp");
  const [radioYearMode, setRadioYearMode] = React.useState<string>("thisComp");
  const [timeCompFlag, setTimeCompFlag] = React.useState<boolean>(false);
  let tempCurrentYearDiffNum: number = 0;
  let tempLastYearDiffNum: number = 0;
  const tempData = React.useRef<any[]>([]);

  const blueTheme = createMuiTheme({
    palette: {
      primary: {
        main: "#DCE6F2",
        contrastText: "#101213",
      },
      secondary: {
        main: "#0000FF",
        contrastText: "#FFF",
      },
    },
  });

  const greenTheme = createMuiTheme({
    palette: {
      primary: {
        main: "#D7E4BD",
        contrastText: "#101213",
      },
      secondary: {
        main: "#00B050",
        contrastText: "#FFF",
      },
    },
  });

  const radioTheme = createMuiTheme({
    overrides: {
      MuiRadio: {
        root: {
          color: "#57bbb4",
        },
        colorSecondary: {
          "&$checked": {
            color: "#57bbb4",
          },
        },
      },
    },
  });

  function errorMsgNoData() {
    setErrorMessage(
      <div>
        対象のデータが存在しません。
        <br />
        日付または分析・比較対象を再度選択してください。
      </div>
    );
  }

  // 初期表示
  useEffect(() => {
    //  前日取得(ローカル開発環境時なら2021/10/31固定)
    const date =
      process.env.NODE_ENV === "development" ||
      process.env.REACT_APP_MODE === "develop"
        ? DateTime.local(2021, 10, 31, 1, 0, 0)
        : DateTime.local().minus({ day: 1 });
    initDate.current = [
      DateTime.local(date.year, date.month, date.day, 0, 0).toFormat(
        "yyyyMMdd"
      ),
    ];
    setFirstDate(initDate.current);
    setSecondDate(initDate.current);
    // グラフおよび表に渡すデータセットの初期化（時間軸）
    tempData.current = initData(24);
  }, []);

  // 分析対象の店舗が変更されたときにグラフ描画データを更新
  useEffect(() => {
    setFirstTenpo();
  }, [firstTenpoItem]);

  // 比較対象の店舗が変更されたときにグラフ描画データを更新
  useEffect(() => {
    setSecondTenpo();
  }, [secondTenpoItem]);

  // 分析対象の日付が変更されたときにグラフ描画データを更新
  useEffect(() => {
    if (baseAxis === 0) {
      setFirstTenpo();
    } else {
      isDoubleUpdate.current = !isSingleSelect() && true;
      handleYearAndAxisMode();
    }
  }, [firstDate]);

  // 比較対象の日付が変更されたときにグラフ描画データを更新
  useEffect(() => {
    if (!axisChange.current) {
      setSecondTenpo();
    }
  }, [secondDate]);

  // 当年/前年モード、軸モードが変更されたときにグラフ描画データを更新
  useEffect(() => {
    isDoubleUpdate.current = !isSingleSelect() && true;
    handleYearAndAxisMode();
  }, [yearOnYear, baseAxis]);

  // 分析対象の店舗が変更されたときの処理
  const setFirstTenpo = async (isModeChange: boolean = false) => {
    // 日付が変更された時に選択されていない方は処理を行わない
    if (firstTenpoItem === "" || firstDate.length === 0) {
      return;
    }
    // 日、週、月比較時の複数日付チェック
    if (checkMultiSelectDate(firstDate, baseAxis)) return;
    // グラフの初期表示
    setInitGraph(true);
    setLoading(true);
    // 天気情報を取得
    const weatherInfo = await getWeatherInfo(
      "first",
      firstTenpoItem,
      firstDate,
      "tenpo"
    );
    setFirstOneYearWeather(weatherInfo.oneYearWeather);
    setFirstDayWeather(weatherInfo.selectedDayWeather);

    // 当年・前年客数をAPIで取得
    const apiRes = await kyakusuRequest(firstTenpoItem, firstDate);

    try {
      // APIで取得したデータから客数の当年実数を抽出
      const kyakusuArrCurrentYear = getKyakusuArr(apiRes, false);
      // 客数の当年実数等をグラフ用データに追加
      const graphData = addKyakusuData(kyakusuArrCurrentYear, "first");

      if (!yearOnYear) {
        setGraphItemCurrentYear(graphData);
        // !isModeChange && displayItemLog();
      } else {
        // 前年比モード時の処理
        // APIで取得したデータから客数の前年実数を抽出
        const kyakusuArrLastYear = getKyakusuArr(apiRes, true);
        // 客数の前年実数等をグラフ用データに追加
        const graphData = addKyakusuDataLastYear(kyakusuArrLastYear, "first");
        setGraphItemLastYear(graphData);
        // !isModeChange && displayItemLog();
      }
    } catch (e) {
      initKyakusuData("first");
      setLoading(false);
      errorMsgNoData();
      setErrorDialog(true);
      isDoubleUpdate.current = false;
    }
  };

  // 比較対象の店舗が変更されたときの処理
  const setSecondTenpo = async (isModeChange: boolean = false) => {
    // 日付が変更された時に選択されていない方は処理を行わない
    if (secondTenpoItem === "" || secondDate.length === 0) {
      return;
    }
    // 日、週、月比較時の複数日付チェック
    if (checkMultiSelectDate(firstDate, baseAxis)) return;
    // グラフの初期表示
    setInitGraph(true);
    setLoading(true);
    // 天気情報を取得
    const weatherInfo = await getWeatherInfo(
      "second",
      secondTenpoItem,
      secondDate,
      "tenpo"
    );
    setSecondOneYearWeather(weatherInfo.oneYearWeather);
    setSecondDayWeather(weatherInfo.selectedDayWeather);

    // 当年・前年客数をAPIで取得
    const apiRes = await kyakusuRequest(secondTenpoItem, secondDate);

    try {
      // APIで取得したデータから客数の当年実数を抽出
      const kyakusuArrCurrentYear = getKyakusuArr(apiRes, false);
      // 客数の当年実数等をグラフ用データに追加
      const graphData = addKyakusuData(kyakusuArrCurrentYear, "second");

      if (!yearOnYear) {
        setGraphItemCurrentYear(graphData);
        // !isModeChange && displayItemLog();
      } else {
        // 前年比モード時の処理
        // APIで取得したデータから客数の前年実数を抽出
        const kyakusuArrLastYear = getKyakusuArr(apiRes, true);
        // 客数の前年実数等をグラフ用データに追加
        const graphData = addKyakusuDataLastYear(kyakusuArrLastYear, "second");

        setGraphItemLastYear(graphData);
        // !isModeChange && displayItemLog();
      }
    } catch (e) {
      initKyakusuData("second");
      setLoading(false);
      errorMsgNoData();
      setErrorDialog(true);
      isDoubleUpdate.current = false;
    }
  };

  // 客数API呼び出し
  const kyakusuRequest = async (tenpoCode: string, date: string[]) => {
    let param: any = {
      "api-name": "kyakusu-summary",
      store_code: tenpoCode,
    };
    const targetDate = baseAxis === 0 ? date : firstDate;
    return apiRequest(param, targetDate, yearOnYear, baseAxis);
  };

  // APIのレスポンスから客数データを抽出
  const getKyakusuArr = (apiRes: any, isYearOnYear: boolean) => {
    const tempArr =
      apiRes.data.dataList !== null && !isYearOnYear
        ? JSON.parse(apiRes.data.dataList[0]).customer_performance_list
        : JSON.parse(apiRes.data.dataList[0])
            .customer_performance_last_year_list;
    if (tempArr.length !== 0) {
      const kyakusuArr = tempArr.map((obj: any) => {
        let timeValue;
        let customerCount = Math.round(obj.customer_count);
        if (baseAxis === 0) {
          // HHの形に整形
          timeValue = Number(obj.target_datetime.substr(0, 2)).toString();
        } else if (baseAxis === 1) {
          if (obj.target_datetime !== "-1") {
            // MM/DDの形に整形
            const tempValue = obj.target_datetime.substr(4, 4).toString();
            const str1 = Number(tempValue.slice(0, 2));
            const str2 = Number(tempValue.slice(2));
            timeValue = str1 + "/\r\n" + str2;
          } else {
            // MIS前年日がない未来日の場合日付が"-1"で返ってくる
            timeValue = "-1";
          }
        } else if (baseAxis === 2) {
          timeValue =
            obj.target_datetime.slice(4, 6).replace(/^0+/, "") +
            "/" +
            obj.target_datetime.slice(6, 8).replace(/^0+/, "") +
            "週";
        } else if (baseAxis === 3) {
          timeValue = obj.target_datetime.slice(4, 6).replace(/^0+/, "") + "月";
          if (timeValue === "1月") {
            timeValue = obj.target_datetime.slice(0, 4) + "年" + timeValue;
          }
        }
        const tempObj = {
          time: timeValue,
          customerCount: customerCount,
        };
        return tempObj;
      });
      // 月軸のAPIレスポンスが逆に入っているバグの暫定対応
      if (baseAxis === 3 && kyakusuArr.length === 12) {
        let tempKyakusuArr = kyakusuArr.map((obj: any) => {
          return obj.customerCount;
        });
        tempKyakusuArr.reverse();
        for (let i = 0; i < 12; i++) {
          kyakusuArr[i].customerCount = tempKyakusuArr[i];
        }
      }
      return kyakusuArr;
    } else {
      const tempObj = {
        time: "-1",
        population: "-",
      };
      let length = 24;
      if (baseAxis === 1) {
        length = 29;
      } else if (baseAxis === 2 || baseAxis === 3) {
        length = 12;
      }
      const kyakusuArr = [];
      for (let i = 0; i < length; i++) {
        kyakusuArr.push(tempObj);
      }
      return kyakusuArr;
    }
  };

  // 客数の当年グラフ用データを追加
  const addKyakusuData = (arr: any, order: string) => {
    let dataFormat: any[] = [];
    if (axisChange.current) {
      // 軸の変更時はデータフォーマットを初期化
      dataFormat = initData(arr.length);
      axisChange.current = false;
    } else {
      dataFormat = tempData.current;
    }

    arr.forEach((value: any, index: number) => {
      dataFormat[index].date = value?.time;
      // 客数当年実数を追加
      if (order === "first") {
        dataFormat[index].firstTenpoRealNumForGraph = value.customerCount;
        dataFormat[index].firstTenpoRealNumForTable = new Intl.NumberFormat(
          "en"
        ).format(value.customerCount);
      } else {
        dataFormat[index].secondTenpoRealNumForGraph = value.customerCount;
        dataFormat[index].secondTenpoRealNumForTable = new Intl.NumberFormat(
          "en"
        ).format(value.customerCount);
      }

      tempCurrentYearDiffNum =
        dataFormat[index]?.firstTenpoRealNumForGraph -
        dataFormat[index]?.secondTenpoRealNumForGraph;
      // 客数当年実数差（グラフ用）を追加
      dataFormat[index].diffForGraph = tempCurrentYearDiffNum;
      // 客数当年実数差（表用）を追加
      dataFormat[index].diffForTable = Intl.NumberFormat("en").format(
        tempCurrentYearDiffNum
      );
    });
    tempData.current = dataFormat;
    return dataFormat;
  };

  // 客数の前年比グラフ用データを追加
  const addKyakusuDataLastYear = (arr: any, order: string) => {
    let dataFormat: any[] = [];
    if (axisChange.current) {
      // 軸の変更時はデータフォーマットを初期化
      dataFormat = initData(arr.length);
      axisChange.current = false;
    } else {
      dataFormat = tempData.current;
    }
    arr.forEach((value: any, index: number) => {
      if (order === "first") {
        // 客数前年実数を追加
        dataFormat[index].firstTenpoRealNumLastYearForGraph =
          value?.time !== "-1" ? value.customerCount : "-";
        dataFormat[index].firstTenpoRealNumLastYearForTable =
          value?.time !== "-1"
            ? new Intl.NumberFormat("en").format(value.customerCount)
            : "-";

        tempLastYearDiffNum =
          dataFormat[index]?.firstTenpoRealNumForGraph -
          dataFormat[index]?.firstTenpoRealNumLastYearForGraph;
        // 客数前年実数差を追加
        dataFormat[index].firstDiffLastYear = tempLastYearDiffNum
          ? new Intl.NumberFormat("en").format(tempLastYearDiffNum)
          : "-";
        // 客数前年比を追加
        dataFormat[index].firstTenpoRatioLastYear =
          dataFormat[index]?.firstTenpoRealNumForGraph !== 0 &&
          dataFormat[index]?.firstTenpoRealNumForGraph !== "-" &&
          dataFormat[index]?.firstTenpoRealNumLastYearForGraph !== 0 &&
          dataFormat[index]?.firstTenpoRealNumLastYearForGraph !== "-"
            ? Math.round(
                (dataFormat[index]?.firstTenpoRealNumForGraph /
                  dataFormat[index]?.firstTenpoRealNumLastYearForGraph) *
                  100
              ).toLocaleString()
            : "-";
      } else {
        // 客数前年実数を追加
        dataFormat[index].secondTenpoRealNumLastYearForGraph =
          value?.time !== "-1" ? value.customerCount : "-";
        dataFormat[index].secondTenpoRealNumLastYearForTable =
          value?.time !== "-1"
            ? new Intl.NumberFormat("en").format(value.customerCount)
            : "-";

        tempLastYearDiffNum =
          dataFormat[index]?.secondTenpoRealNumForGraph -
          dataFormat[index]?.secondTenpoRealNumLastYearForGraph;
        // 客数前年実数差を追加
        dataFormat[index].secondDiffLastYear = tempLastYearDiffNum
          ? new Intl.NumberFormat("en").format(tempLastYearDiffNum)
          : "-";
        // 客数前年比を追加
        dataFormat[index].secondTenpoRatioLastYear =
          dataFormat[index]?.secondTenpoRealNumForGraph !== 0 &&
          dataFormat[index]?.secondTenpoRealNumForGraph !== "-" &&
          dataFormat[index]?.secondTenpoRealNumLastYearForGraph !== 0 &&
          dataFormat[index]?.secondTenpoRealNumLastYearForGraph !== "-"
            ? Math.round(
                (dataFormat[index]?.secondTenpoRealNumForGraph /
                  dataFormat[index]?.secondTenpoRealNumLastYearForGraph) *
                  100
              ).toLocaleString()
            : "-";
      }
      // 客数前年比差を追加
      dataFormat[index].ratioDiff =
        dataFormat[index]?.firstTenpoRatioLastYear !== 0 &&
        dataFormat[index]?.firstTenpoRatioLastYear !== "-" &&
        dataFormat[index]?.secondTenpoRealNumLastYearForGraph !== 0 &&
        dataFormat[index]?.secondTenpoRealNumLastYearForGraph !== "-"
          ? dataFormat[index].firstTenpoRatioLastYear -
            dataFormat[index].secondTenpoRatioLastYear
          : "-";
    });
    tempData.current = dataFormat;
    return dataFormat;
  };

  // 客数のグラフ・テーブルデータを初期化
  const initKyakusuData = (order: string) => {
    tempData.current?.forEach((data: any, index: number) => {
      if (order === "first") {
        data.firstTenpoRealNumForGraph =
          data.hasOwnProperty("firstTenpoRealNumForGraph") && 0;
        data.firstTenpoRealNumForTable =
          data.hasOwnProperty("firstTenpoRealNumForTable") && "";
        data.firstTenpoRealNumLastYearForGraph =
          data.hasOwnProperty("firstTenpoRealNumLastYearForGraph") && 0;
        data.firstTenpoRealNumLastYearForTable =
          data.hasOwnProperty("firstTenpoRealNumLastYearForTable") && "";
        data.firstDiffLastYear = data.hasOwnProperty("firstDiffLastYear") && 0;
        data.firstTenpoRatioLastYear =
          data.hasOwnProperty("firstTenpoRatioLastYear") && 0;
      } else {
        data.secondTenpoRealNumForGraph =
          data.hasOwnProperty("secondTenpoRealNumForGraph") && 0;
        data.secondTenpoRealNumForTable =
          data.hasOwnProperty("secondTenpoRealNumForTable") && "";
        data.secondTenpoRealNumLastYearForGraph =
          data.hasOwnProperty("secondTenpoRealNumLastYearForGraph") && 0;
        data.secondTenpoRealNumLastYearForTable =
          data.hasOwnProperty("secondTenpoRealNumLastYearForTable") && "";
        data.secondDiffLastYear =
          data.hasOwnProperty("secondDiffLastYear") && 0;
        data.secondTenpoRatioLastYear =
          data.hasOwnProperty("secondTenpoRatioLastYear") && 0;
      }
      data.diffForGraph = data.hasOwnProperty("diffForGraph") && 0;
      data.diffForTable = data.hasOwnProperty("diffForTable") && "";
      // data.conversionRateForGraph =
      //   data.hasOwnProperty("conversionRateForGraph") && 0;
      // data.conversionRateForTable =
      //   data.hasOwnProperty("conversionRateForTable") && "";
      // data.ratioDiff = data.hasOwnProperty("ratioDiff") && 0;
      // data.conversionRateLastYearForGraph =
      //   data.hasOwnProperty("conversionRateLastYearForGraph") && 0;
      // data.conversionRateLastYearForTable =
      //   data.hasOwnProperty("conversionRateLastYearForTable") && "";
    });
    setData(tempData.current);
  };

  // 当年データのグラフ設定
  const setGraphItemCurrentYear = (graphData: any) => {
    if (!isDoubleUpdate.current) {
      setData(graphData);
      // 当年のグラフコンポーネントに切り替え
      setYearOnYearMode(false);
      setLoading(false);
    } else {
      isDoubleUpdate.current = false;
    }
  };

  // 前年データのグラフ設定
  const setGraphItemLastYear = (graphData: any) => {
    if (!isDoubleUpdate.current) {
      setData(graphData);
      // 前年のグラフコンポーネントに切り替え
      setYearOnYearMode(true);
      setLoading(false);
    } else {
      isDoubleUpdate.current = false;
    }
  };

  // 軸モード、当年/前年モードの切り替え
  const handleYearAndAxisMode = () => {
    setFirstTenpo(true);
    setSecondTenpo(true);
    // logFlag.current && displayItemLog();
    logFlag.current = true;
  };

  const isSingleSelect = () => {
    if (firstTenpoItem === "" || secondTenpoItem === "") {
      return true;
    } else {
      return false;
    }
  };

  function checkMultiSelectDate(date: string[], axis: number) {
    if (date.length !== 1 && axis !== 0) {
      let modeCaption = "";
      if (axis === 1) {
        modeCaption = "日別比較";
      } else if (axis === 2) {
        modeCaption = "週別比較";
      } else if (axis === 3) {
        modeCaption = "月別比較";
      }
      setErrorMessage(
        <div>
          {modeCaption}では複数日付を選択できません。
          <br />
          日付を再度選択してください。
        </div>
      );
      setErrorDialog(true);
      // ローディングアイコン表示
      setLoading(false);
      return true;
    }
    return false;
  }

  const handleRadioClick = (event: any, axis: number) => {
    if (checkMultiSelectDate(firstDate, axis)) {
      setBaseAxis(0);
      return;
    } else {
      axisChange.current = true;
      setSecondDate(firstDate);
      setRadioAxisMode(event.target.value);
      setBaseAxis(axis);
    }
  };

  const timeCompFlagFunc = () => {
    setTimeCompFlag(false);
  };

  return (
    <>
      {loading && (
        <CircularProgress className={classes.circularProgress} size={120} />
      )}
      <div
        className={classes.overLayer}
        style={
          loading
            ? { backgroundColor: "#CCC", opacity: "0.5", pointerEvents: "none" }
            : {}
        }
      >
        {/* <div className={classes.overLayer}> */}
        {errorDialog && (
          <div className={classes.backLayer}>
            <div className={classes.errorDialog}>
              <div className={classes.errorDialogCloseButton}>
                <IconButton
                  onClick={() => setErrorDialog(false)}
                  size={"small"}
                >
                  <HighlightOffIcon />
                </IconButton>
              </div>
              <Typography variant="h6" style={{ color: "red" }}>
                {errorMessage}
              </Typography>
            </div>
          </div>
        )}
        <div className={classes.graphBox}>
          {/* 日付選択・天気情報 */}
          <Grid container>
            <Grid item xs={9}>
              <Grid container alignItems="center" spacing={3}>
                <Grid item xs={2}>
                  <Paper className={classes.titlePaperFirst}>分析対象</Paper>
                </Grid>
                <Grid item xs={3}>
                  <MultiDatePicker
                    dateFunc={(dates: string[]) => {
                      setFirstDate(dates);
                    }}
                    oneYearWeather={firstOneYearWeather}
                    holiday={holiday}
                  />
                </Grid>
                <Grid item xs={1}>
                  <GraphWeather dayWeather={firstDayWeather}></GraphWeather>
                </Grid>
                {baseAxis === 0 && (
                  <>
                    <Grid item xs={2}>
                      <Paper className={classes.titlePaperSecond}>
                        比較対象
                      </Paper>
                    </Grid>
                    <Grid item xs={3}>
                      <MultiDatePicker
                        dateFunc={(dates: string[]) => {
                          setSecondDate(dates);
                        }}
                        oneYearWeather={secondOneYearWeather}
                        holiday={holiday}
                        firstDate={firstDate}
                        timeCompFlag={timeCompFlag}
                        timeCompFlagFunc={timeCompFlagFunc}
                      />
                    </Grid>
                    <Grid item xs={1}>
                      <GraphWeather
                        dayWeather={secondDayWeather}
                      ></GraphWeather>
                    </Grid>
                  </>
                )}
              </Grid>
              {/* メッシュ・店舗選択ボタン */}
              <Grid container>
                <Grid item xs={6}>
                  <Typography variant="body2" style={{ color: "#0000FF" }}>
                    ▼下のボタンから客数を比較したい店舗を選んでください
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="body2" style={{ color: "#00B050" }}>
                    ▼下のボタンから客数を比較したい店舗を選んでください
                  </Typography>
                </Grid>
              </Grid>
              {/* 店舗選択ボタン */}
              <Grid container alignItems="center" spacing={2}>
                <ThemeProvider theme={blueTheme}>
                  <Grid item xs={4}>
                    <SelectStoreMenu
                      itemOrder={"first"}
                      itemValue={firstTenpoItem}
                      graphType={"tenpo"}
                    />
                  </Grid>
                </ThemeProvider>
                <Grid item xs={2}></Grid>
                <ThemeProvider theme={greenTheme}>
                  <Grid item xs={4}>
                    <SelectStoreMenu
                      itemOrder={"second"}
                      itemValue={secondTenpoItem}
                      graphType={"tenpo"}
                    />
                  </Grid>
                </ThemeProvider>
                <Grid item xs={2}></Grid>
              </Grid>
            </Grid>
            {/* 軸・モード切り替えラジオボタン */}
            <Grid item xs={3}>
              <Grid container justify="flex-end">
                <Grid item xs={5}>
                  <ThemeProvider theme={radioTheme}>
                    <FormControl>
                      <FormLabel id="comparisonGroupLabel"></FormLabel>
                      <RadioGroup
                        aria-labelledby="comparisonGroupLabel"
                        defaultValue="timeComp"
                        name="comparisonGroup"
                        value={radioAxisMode}
                      >
                        <FormControlLabel
                          value="timeComp"
                          control={
                            <Radio
                              size="small"
                              onClick={(event) => {
                                setTimeCompFlag(true);
                                handleRadioClick(event, 0);
                              }}
                            />
                          }
                          label={
                            <Typography variant="caption">
                              時間帯別比較
                            </Typography>
                          }
                        />
                        <FormControlLabel
                          value="dayComp"
                          control={
                            <Radio
                              size="small"
                              onClick={(event) => {
                                handleRadioClick(event, 1);
                              }}
                            />
                          }
                          label={
                            <Typography variant="caption">日別比較</Typography>
                          }
                        />
                        <FormControlLabel
                          value="weekComp"
                          control={
                            <Radio
                              size="small"
                              onClick={(event) => {
                                handleRadioClick(event, 2);
                              }}
                            />
                          }
                          label={
                            <Typography variant="caption">週比較</Typography>
                          }
                        />
                        <FormControlLabel
                          value="monthComp"
                          control={
                            <Radio
                              size="small"
                              onClick={(event) => {
                                handleRadioClick(event, 3);
                              }}
                            />
                          }
                          label={
                            <Typography variant="caption">月比較</Typography>
                          }
                        />
                      </RadioGroup>
                    </FormControl>
                  </ThemeProvider>
                </Grid>
                <Grid item xs={5}>
                  <ThemeProvider theme={radioTheme}>
                    <FormControl>
                      <FormLabel id="comparisonModeLabel"></FormLabel>
                      <RadioGroup
                        aria-labelledby="comparisonModeLabel"
                        defaultValue="thisComp"
                        name="comparisonMode"
                        value={radioYearMode}
                      >
                        <FormControlLabel
                          value="thisComp"
                          control={
                            <Radio
                              size="small"
                              onClick={() => {
                                setYearOnYear(false);
                                setRadioYearMode("thisComp");
                              }}
                            />
                          }
                          label={
                            <Typography variant="caption">当年ﾓｰﾄﾞ</Typography>
                          }
                        />
                        <FormControlLabel
                          value="preComp"
                          control={
                            <Radio
                              size="small"
                              onClick={() => {
                                setYearOnYear(true);
                                setRadioYearMode("preComp");
                              }}
                            />
                          }
                          label={
                            <Typography variant="caption">前年ﾓｰﾄﾞ</Typography>
                          }
                        />
                      </RadioGroup>
                    </FormControl>
                  </ThemeProvider>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          {yearOnYearMode ? (
            <GraphContentZennenhiTenpoMobaku
              data={data}
              graphType={"tenpo"}
              baseAxis={baseAxis}
              firstDate={firstDate[0]}
              today={initDate.current[0]}
            />
          ) : (
            <GraphContentTenpoMobaku
              data={data}
              graphType={"tenpo"}
              initGraph={initGraph}
              baseAxis={baseAxis}
              firstDate={firstDate[0]}
              today={initDate.current[0]}
            />
          )}
          {initGraph &&
            (yearOnYearMode ? (
              <Grid container>
                <Grid item xs={12}>
                  <TableContentZennenhiTenpoMobaku
                    data={data}
                    graphType={"tenpo"}
                    tableOpen={tableOpen}
                    baseAxis={baseAxis}
                    firstDate={firstDate[0]}
                    holiday={holiday}
                    today={initDate.current[0]}
                  />
                </Grid>
              </Grid>
            ) : (
              <Grid container>
                <Grid item xs={12}>
                  <TableContentTenpoMobaku
                    data={data}
                    graphType={"tenpo"}
                    baseAxis={baseAxis}
                    firstDate={firstDate[0]}
                    holiday={holiday}
                    today={initDate.current[0]}
                  />
                </Grid>
              </Grid>
            ))}
          {yearOnYearMode &&
            (tableOpen ? (
              <IconButton onClick={() => setTableOpen("")}>
                <AddCircleOutlineIcon fontSize="small" />
              </IconButton>
            ) : (
              <IconButton onClick={() => setTableOpen("none")}>
                <RemoveCircleOutlineIcon fontSize="small" />
              </IconButton>
            ))}
        </div>
      </div>
    </>
  );
};

export default TenpoGraphAnalysis;
